exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;position:relative;text-align:center;vertical-align:middle}.qmodii .v-avatar .v-icon,.qmodii .v-avatar .v-image,.qmodii .v-avatar img{border-radius:50%;display:inline-flex;height:inherit;width:inherit}.qmodii .v-avatar--tile,.qmodii .v-avatar--tile .v-icon,.qmodii .v-avatar--tile .v-image,.qmodii .v-avatar--tile img{border-radius:0}", ""]);

// exports
